import React from 'react'
import { WidgetGuard } from 'features/types'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  TopicLanguageNotSupportedGuard,
  UnexpectedServiceErrorGuard
} from '../../share/guards'
import EmptyResultGuard from './EmptyResultGuard'
import ResultBelowThresholdGuard from './ResultBelowThresholdGuard'

const StoryScopeWidgetDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <UnexpectedServiceErrorGuard widgetId={widgetId}>
      <TopicIndexNotReadyGuard widgetId={widgetId}>
        <TopicLanguageNotSupportedGuard widgetId={widgetId}>
          <EmptyResultGuard widgetId={widgetId}>
            <ResultBelowThresholdGuard widgetId={widgetId}>{children}</ResultBelowThresholdGuard>
          </EmptyResultGuard>
        </TopicLanguageNotSupportedGuard>
      </TopicIndexNotReadyGuard>
    </UnexpectedServiceErrorGuard>
  </TopicInaccessibleGuard>
)

export default StoryScopeWidgetDataGuards
